/**
 * SyllableSegmentationResultService class to manage GSF puzzle activities and hard mode state.
 */
class SyllableSegmentationResultService {
  /**
   * Static variable to indicate whether hard mode is active.
   * @type {boolean}
   */
  static isHardMode = false;

  /**
   * Static variable to store the results of GSF puzzle activities.
   * @type {number[]}
   * @private
   */
  static #resultsStore = [];

  /**
   * Adds the result of a completed GSF puzzle to the results store.
   * @param {number} result - The result of the GSF puzzle (1 for success, 2 for fail).
   */
  static addPuzzleResult(result) {
    SyllableSegmentationResultService.#resultsStore.push(result);
    SyllableSegmentationResultService.#checkHardMode();
  }

  /**
   * Checks the results store to determine if hard mode should be activated.
   * @private
   */
  static #checkHardMode() {
    const length = SyllableSegmentationResultService.#resultsStore.length;
    if (
      length >= 2 &&
      SyllableSegmentationResultService.#resultsStore[length - 1] === 1 &&
      SyllableSegmentationResultService.#resultsStore[length - 2] === 1
    ) {
      SyllableSegmentationResultService.isHardMode = true;
    }
  }
}

export default SyllableSegmentationResultService;
